import React, { useContext, useEffect } from 'react';
import { resolveBrandFromEnvironment } from '|/brand';
import UserInitializationContext from '|/context/user-initialization-context';
import { refreshTokenIfMissing } from '|/helpers/axios';

const RedirectToHome = () => {
  const { accessToken } = useContext(UserInitializationContext);

  useEffect(() => {
    if (resolveBrandFromEnvironment() === 'slate') {
      void refreshTokenIfMissing().then(() => {
        // Success leaves a usable access token → reload into the flow. Failure paths
        // (no refresh token / 4XX / 5XX) already navigated to login/speedbump.
        if (accessToken?.user?.name) {
          window.location.href = `${window.location.origin}/purchase`;
        } else {
          window.location.href = `${window.location.origin}/login?provider=SlateFusionAuth`;
        }
      });
      return;
    }

    const query = `?openAccountModal=signIn&ReturnUrl=${encodeURIComponent('/purchase')}`;
    window.location.href = `${window.location.origin}/${query}`;
  }, []);

  return null;
};

const AccountLogin = () => {
  return <RedirectToHome />;
};

export default AccountLogin;
